<template>
  <div class="tbpay">
    <p class="title">淘宝付费后，卡密自助充值 、续费</p>
    <div class="recharge">
      <el-form status-icon ref="obj" label-width="100px" :model="obj">
        <el-form-item label="充值卡卡号：" prop="pass" size="mini">
          <el-input type="text" v-model="obj.card_id" autocomplete="off" placeholder="请不要带空格，否则提示无效"></el-input>
        </el-form-item>
        <el-form-item label="充值卡卡密：" prop="checkPass" size="mini">
          <el-input type="text" v-model="obj.card_pwd" autocomplete="off" placeholder="请不要带空格，否则提示无效"></el-input>
        </el-form-item>
        <el-form-item>
          <span class="btn" @click="clear_obj">重置</span>
          <span class="btn" @click="handleRecharge('obj')">开始充值</span>
        </el-form-item>
      </el-form>
    </div>
    <!-- <div class="notice">
      <p>淘宝拍完后，请用旺旺收到的卡号密码在此续费</p>
      <p>如旺旺没有收到，也可以到这里提取卡密</p>
      <p>
        <el-link href="http://alds.agiso.com/?viQbMb" target="_blank">http://alds.agiso.com/?viQbMb</el-link>
      </p>
    </div>
    <table>
      <tbody class="tb_link">
      <tr v-for="(item,index) in data_pay" :key="index" v-if="item.url">
        <td class="vip sty">{{item.vip}}</td>
        <td class="link sty">
          <el-link :href="item.url" target="_blank">{{item.url}}</el-link>
        </td>
      </tr>
      </tbody>
    </table> -->
    <p class="notice_text">
      ***特殊资源定制会员 : 不支持自助充值续费，请联系客服详谈***
    </p>
    <el-dialog
      :title="title"
      :visible.sync="upDialogVisible"
      width="30%"
      @close="cancel"
      center>
      <span v-if="title === '升级'">当前用户已经购买: <font color="red">{{up.name}}</font> <br>到期时间: <font color="red">{{up.end_time}}</font><br>
        升级转化为: <font color="red">{{up.cur}}</font><br>转化后累加天数为: <font color="red">{{up.y_days}}</font><br> 如需更换会员，我们采用升级处理!</span>
      <span v-else-if="title ==='续费'">
          <span>
            当前未到过期时间，是否进行续费?<br>
          </span>
        <span v-if="!!this.content_re">
          当前线程为: <font color="red">{{this.content_re.cur_thread_num}}<br></font>
          线程数转为: <font color="red">{{this.content_re.thread_num}}<br></font>
          转化天数为: <font color="red">{{this.content_re.time}}<br></font>
        </span>
      </span>
      <span v-else-if="title==='抱歉'">
        当前用户的会员信息为: <font color="red">{{content_error.cur.group}}</font> , 当前用户线程数为: <font color="red">{{content_error.cur.thread_num}}</font><br>
        卡密的信息为: <font color="red">{{content_error.card.group}}</font> , 卡密线程数为: <font color="red">{{content_error.card.thread_num}}</font><br>
        不允许跨线程数或跨会员组进行充值,如有疑问请联系客服,我们将妥善处理!
      </span>
      <span slot="footer" class="dialog-footer">
    <el-button @click="cancel">取 消</el-button>
    <el-button type="primary" @click="operation">确 定</el-button>
  </span>
    </el-dialog>
  </div>
</template>

<script>
  import qs from 'qs'

  export default {
    data() {
      return {
        obj: {
          card_id: null,
          card_pwd: null,
        },
        data_pay: [],
        upDialogVisible: false,
        title: '',
        up: {},
        content_re: '',
        content_error: '',
      }
    },
    async mounted() {
      // await this.$http.getTradeType().then(res => {
      //   this.data_pay = res.data
      //   console.log(this.data_pay)
      // })
    },
    methods: {
      clear_obj () {
        this.obj.card_id = null
        this.obj.card_pwd = null
      },
      cancel() {
        this.upDialogVisible = false
        try {
          delete this.obj.up
          delete this.this.obj.day
        } catch (e) {
        }
      },
      operation() {
        if (this.title === '抱歉') {
          this.upDialogVisible = false
        }
        this.$http.postCardRecharge(qs.stringify(this.obj)).then(res => {
          if (res.code === 200) {
            this.upDialogVisible = false
            this.$message({
              message: res.msg,
              type: 'success',
              customClass: 'hint-message',
              center: true
            });
          }
        })
      },
      handleRecharge(formName) {
        this.$refs[formName].validate(valid => {
          if (valid) {
            this.$http.postCardRecharge(qs.stringify(this.obj)).then(res => {
              if (res.code === 200) {
                this.$message({
                  message: '充值成功',
                  type: 'success',
                  customClass: 'hint-message',
                  center: true
                });
              } else if (res.code === 300) {
                this.upDialogVisible = true
                this.title = '续费'
                this.obj.up = 'renewal'
                this.content_re = res.data
              } else if (res.code === 301) {
                this.upDialogVisible = true
                this.title = '升级'
                this.obj.up = 'upgrade'
                this.up = res.data
                this.obj.day = res.data.y_days
              } else if (res.code === 3001) {
                this.upDialogVisible = true
                this.title = '抱歉'
                this.content_error = res.data
              } else {
                this.$message({
                  message: res.msg,
                  type: 'error',
                  customClass: 'hint-message',
                  center: true
                });
              }
            }).catch(err => {
              console.log('err', err)
            })
          } else {
            console.log("error submit!!");
            return false;
          }
        });
      }
    }
  }
</script>
<style scoped>
  .title {
    padding-left: 150px;
  }

  .recharge {
    margin-top: 20px;
    margin-left: 50px;
    width: 300px;
  }

  .btn {
    height: 28px;
    line-height: 28px;
    color: white;
    border: 0;
    background-color: #A7231E;
    font-weight: bold;
    font-size: 14px;
    padding: 5px 10px;
    margin: 0 15px;
  }

  .btn:hover {
    cursor: pointer;
    background-color: rgb(207, 50, 44);
  }

  .notice {
    text-align: center;
    width: 500px;
  }

  .notice p {
    padding-top: 5px;
  }

  .notice_text {
    width: 550px;
    margin-top: 10px;
    text-align: center;
    color: red;
    font-weight: 600;
  }

  .tb_link {
    width: 636px;
    display: block;
    margin-top: 20px;
    position: relative;
    right: 50px;
    border: 1px solid #00B0F1;
  }

  .vip {
    width: 254px;
  }

  .link {
    width: 363px;
  }

  .sty {
    height: 50px;
    padding-left: 8px;
    font-size: 14px;
    border: 1px solid #00B0F1;
    vertical-align: middle;
  }
</style>
